import { render, staticRenderFns } from "./BankOffers.vue?vue&type=template&id=fdf1e070&"
import script from "./BankOffers.vue?vue&type=script&lang=js&"
export * from "./BankOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports